import { TgtLogger } from '@measurement/opentelemetry-web'

const getErrorMessage = (error) => {
  if (error instanceof Error) {
    return error.message
  }

  if (typeof error === 'string') {
    return error
  }

  try {
    return JSON.stringify(error)
  } catch {
    return 'Unknown error'
  }
}

const getErrorType = (error) => {
  if (error instanceof Error && error.name) {
    return error.name
  }

  return typeof error
}

const getErrorStack = (error) => {
  if (error instanceof Error) {
    return error.stack
  }

  return undefined
}

const sanitizeUndefinedFields = (obj = {}) =>
  Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== undefined),
  )

const RESERVED_CONTEXT_KEYS = new Set(['userId', 'pathname', 'search'])

export const logTcsError = ({
  message,
  error,
  context = {},
  nonIndexedFields = {},
}) => {
  const safeContext = sanitizeUndefinedFields(context)
  const safeNonIndexed = sanitizeUndefinedFields(nonIndexedFields)
  const standardContext = {
    userId: safeContext.userId,
    pathname: safeContext.pathname,
    search: safeContext.search,
  }

  const contextualFields = sanitizeUndefinedFields(
    Object.fromEntries(
      Object.entries(safeContext).filter(
        ([key]) => !RESERVED_CONTEXT_KEYS.has(key),
      ),
    ),
  )

  TgtLogger.error(message, {
    error: sanitizeUndefinedFields({
      message: getErrorMessage(error),
      type: getErrorType(error),
      stack_trace: getErrorStack(error),
    }),
    user: sanitizeUndefinedFields({
      id: standardContext.userId,
    }),
    url: sanitizeUndefinedFields({
      path: standardContext.pathname ?? window?.location?.pathname,
      query: standardContext.search ?? window?.location?.search,
    }),
    nonIndexedFields: {
      ...contextualFields,
      ...safeNonIndexed,
    },
  })
}

export const createTcsErrorLogger = ({ getBaseContext } = {}) => {
  return ({ message, error, context, nonIndexedFields }) => {
    const baseContext = getBaseContext ? getBaseContext() : {}

    logTcsError({
      message,
      error,
      context: {
        ...baseContext,
        ...context,
      },
      nonIndexedFields,
    })
  }
}
